import { useEffect } from 'react';
import AppRoutes from './AppRoutes';
import { AuthProvider } from './context/AuthContext';
import { HttpProvider } from './context/HttpContext';
import { RedirectionContextProvider } from './context/RedirectionContext';
import { CookieConsentProvider } from './cookieConsent';
import { captureEmailCtaStage } from './components/client/onboarding/useTrackEmailCtaClick';

function App() {
  useEffect(() => {
    captureEmailCtaStage();
  }, []);

  return (
    <CookieConsentProvider>
      <AuthProvider>
        <HttpProvider>
          <RedirectionContextProvider>
            <AppRoutes />
          </RedirectionContextProvider>
        </HttpProvider>
      </AuthProvider>
    </CookieConsentProvider>
  );
}

export default App;
